import Alpine from "alpinejs";
import Glide from "@glidejs/glide";

document.addEventListener("alpine:init", () => {
  Alpine.data("modal", () => ({
    open: false,
    toggle() {
      this.open = !this.open;
    },
  }));
});

window.Alpine = Alpine;

Alpine.start();

let glide = new Glide(".glide", {
  type: "carousel",
  perView: 4,
  gap: 0,
  breakpoints: {
    1024: {
      perView: 3,
    },
    768: {
      perView: 2,
    },
    640: {
      perView: 1,
    },
  },
});

glide.mount();

new Glide(".glide_section_10", {
  type: "carousel",
  perView: 1,
  gap: 0,
  breakpoints: {
    1024: {
      perView: 1,
    },
  },
}).mount();
